<script setup lang="ts">
import { computed } from 'vue'

import Restart from '@material-symbols/svg-400/rounded/replay.svg'

import ResultGauge from './ResultGauge.vue'

import { state } from '../state'

function onClick() {
  window.location.reload()
}

const resultValue = computed(() => state.result!.risk!);

const scoreText = computed(() => {
  const value = Math.min(Math.max(Math.round(resultValue.value), 1), 5)
  switch (value) {
    case 1:
      return 'Low risk'
    case 2:
      return 'Risk'
    case 3:
      return 'High risk'
    case 4:
      return 'Pre-diabetes'
    case 5:
      return 'Diabetes'
    default:
      return 'Unknown'
  }
})
</script>
<template>
  <div class="p-8 text-center dark:text-gray-300">
    <Transition name="fade" appear>
      <div v-if="true">
        <p class="text-xl">Your test result</p>
        <div class="flex items-center justify-center flex-col mt-4">
          <div class="shadow-md rounded-md border-double border-4 w-full">
            <ResultGauge :value="resultValue" />
          </div>
          <div
            class="flex items-center rounded-md my-4 px-8 py-4 text-xl font-bold border shadow-md divide-x-2 space-x-4"
          >
            <span class="">{{ resultValue }}</span>
            <span class="pl-4">
              {{ scoreText }}
            </span>
          </div>
        </div>
      </div>
    </Transition>
    <div class="flex justify-center my-4 text-sm">
      <button @click="onClick" class="btn-next py-2 px-4">
        Check another barcode
        <Restart class="w-4 h-4 ml-2" />
      </button>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1500ms ease-in;
  opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
